import {Command} from 'src/app/domain/command/command.command';
import {uuid} from 'src/app/domain/function/uuid.helper';

/* eslint-disable @typescript-eslint/naming-convention */
export interface UploadVat extends Command {
  'files[0]': File | null;
  'files[1]': File | null;
}

export const createEmptyUploadVat = (): UploadVat => ({
  commandId: uuid(),
  'files[0]': null,
  'files[1]': null
});
